import useProtectedMutation from './use-protected-mutation';

import RebatesClient from '../RebatesClient';

/**
 * Persists a statement snapshot via POST /api/report/statements.
 *
 * The snapshot is the payload produced by buildStatementSnapshot(). Ownership
 * and the reference are assigned server-side, so they are not sent here.
 *
 * Returns the react-query mutation. On success the saved statement
 * ({ id, reference, created_at }) is available as the mutation result.
 */
export default function useSaveStatement() {
  return useProtectedMutation({
    mutationKey: ['save_statement'],
    mutationFn: async (snapshot) => {
      const result = await RebatesClient.saveStatement(snapshot);

      if (!result.response.ok) {
        throw new Error(result.body?.status || 'Error saving statement');
      }

      return result.body?.statement || null;
    }
  });
}
